import React from "react";
import { Link } from "react-router-dom";
import "../App.css";

const TermsOfService = () => {
  return (
    <div
      className="hhg-hero-container"
      style={{
        flexDirection: "column",
        alignItems: "center",
        padding: "80px 20px",
        marginTop: "60px",
        background: "#ffffff",
      }}
    >
      <div
        className="hhg-hero-inner"
        style={{ flexDirection: "column", maxWidth: "3200px" }}
      >
        {/* <h1
        className="hhg-hero-heading"
        style={{
          textAlign: "center",
          marginBottom: "40px",
          fontSize: "42px",
          fontWeight: "700",
          color: "#0a4d68",
          letterSpacing: "1px",
        }}
      >
        Terms of Service
      </h1> */}

         <div
        className="terms-content"
        style={{
          maxWidth: "3000px",
          background: "#fafafa",
          padding: "40px 50px",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          fontSize: "17px",
          color: "#333",
          lineHeight: "1.8",
          fontFamily: "Kanit, sans-serif",
        }}
      >
          <h3
          style={{
            textAlign: "center",
            color: "#0a4d68",
            marginBottom: "25px",
            fontSize: "24px",
          }}
        >
          TERMS OF SERVICE
        </h3>

          <p>
            HHG INDUSTRIES PRIVATE LIMITED (“us”, “we” or “our” as the context requires)
            provides an informational website and platform for accessing content,
            articles, guides, and other general information (the “Services”) via our
            websites, and other platforms (the “Platforms”). For the purpose of this
            Terms of Service, wherever the context so requires "you" or "your" shall
            mean The User.
          </p>

          {/* ------------------ POINT 1 WITH LINKS ------------------ */}
          <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>1. ACCEPTANCE OF TERMS</h4>
          <p>
            These terms and conditions (“Terms”) govern your access to and use of our
            Services and Platforms, together with our{" "}
            <Link
              to="/PrivacyPolicy"
              style={{ color: "#0a4d68", textDecoration: "underline" }}
            >
              privacy policy
            </Link>{" "}
            and{" "}
            <Link
              to="/CookiePolicy"
              style={{ color: "#0a4d68", textDecoration: "underline" }}
            >
              cookie policy
            </Link>
            . By accessing or using the Services or Platforms, you are confirming that
            you are above 18 Years of age, have read, understood and agreed to these
            Terms and those of the privacy policy and cookie policy.
          </p>
          <p>
            We may amend these Terms at any time at our discretion. If these Terms are
            amended, we will publish the revised terms and conditions and you will be
            deemed to have accepted any amendments if you continue using our Services or
            Platforms after the amendments are displayed. If you do not accept all of
            these Terms then you should not use our Services or Platforms.
          </p>

          {/* ------------------ POINT 2 ------------------ */}
          <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>2. ELIGIBILITY TO USE</h4>
          <p>
            You must be at least 18 years of age and must possess the legal authority to
            enter into an agreement so as to become a User and use the services of
            HHG INDUSTRIES PRIVATE LIMITED. If you are a minor or are below the age of 18
            years, you shall not register as a User of the Website and shall not
            transact on, via or use the Website.
          </p>

          {/* ------------------ POINT 3 ------------------ */}
          <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>3. USER OBLIGATIONS AND PROHIBITED ACTIVITIES</h4>
          <p>
            You agree not to use the Services or Platforms for any illegal,
            unauthorized, unintended, or harmful purpose. Prohibited activities
            include, but are not limited to:
          </p>
          <ul style={{ listStyle: "disc", marginLeft: "40px" }}>
            <li>Violating any applicable local, state, national, or international law or regulation.</li>
            <li>Infringing upon or violating our intellectual property rights or the intellectual property rights of others.</li>
            <li>Engaging in spamming, harassment, or transmitting viruses, worms, or any code of a destructive nature.</li>
            <li>
              Attempting to gain unauthorized access to any portion or feature of the
              Platforms, or any other systems or networks connected to the Platforms.
            </li>
          </ul>

          {/* ------------------ POINT 4 ------------------ */}
          <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>4. INTELLECTUAL PROPERTY RIGHTS</h4>
          <p>
            The Platforms and all content, materials, information, and intellectual
            property on the Platforms, including but not limited to text, graphics,
            logos, images, software, and the compilation thereof (collectively, the
            “Content”), are the exclusive property of HHG INDUSTRIES PRIVATE LIMITED and are
            protected by copyright, trademark, and other intellectual property laws
          </p>
          <p>
            You agree not to modify, copy, distribute, transmit, display, perform,
            reproduce, publish, license, create derivative works from, transfer, or sell
            any information, software, products, or services obtained from the Platforms,
            except for your own personal, non-commercial use.
          </p>

          {/* ------------------ POINT 5 ------------------ */}
          <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>5. DISCLAIMER OF INFORMATION AND NO PROFESSIONAL ADVICE</h4>
          <p><strong>A. Informational Purposes Only:</strong> The content provided on our Platforms and Services is for general informational purposes only and is not intended to serve as professional advice.</p>
          <p><strong>B. No Reliance:</strong> You acknowledge that any reliance upon the Services and Platforms, including any Content, shall be at your sole risk. HHG INDUSTRIES PRIVATE LIMITED is not responsible or liable for any loss or damage of any kind arising from the use of, or reliance on, any Content.</p>

          {/* ------------------ POINT 6 ------------------ */}
          <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>6. DISCLAIMER OF WARRANTIES</h4>
          <p>
            The Services and Platforms are provided on an “as is” and “as available”
            basis HHG INDUSTRIES PRIVATE LIMITED hereby expressly disclaims all warranties of
            any kind, whether express or implied, including, but not limited to, implied
            warranties of merchantability, fitness for a particular purpose, and
            non-infringement. We make no warranty that the Services or Platforms will
            meet your requirements, or that your use of the Services or Platforms will be
            uninterrupted, timely, secure, or error-free.
          </p>

          {/* ------------------ POINT 7 ------------------ */}
          <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>7. LIMITATION OF LIABILITY</h4>
          <p>
            In no event shall HHG INDUSTRIES PRIVATE LIMITED be liable for any direct,
            indirect, punitive, incidental, special or consequential damages, and any
            other damages like damages for loss of use, data or profits, arising out of
            or in any way connected with the use or performance of the Website or any
            other Sales Channel.
          </p>

          {/* ------------------ POINT 8 ------------------ */}
          <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>8. LINKS TO THIRD-PARTY SITES</h4>
          <p>
            The Platforms may contain links to other websites ("Linked Sites"). The
            Linked Sites are not under the control of HHG INDUSTRIES PRIVATE LIMITED and we are
            not responsible for the content of any Linked Site. The inclusion of any link
            does not imply endorsement by HHG INDUSTRIES PRIVATE LIMITED of the site or any
            association with its operators. You use the Linked Sites at your own risk.
          </p>

          {/* ------------------ POINT 9 ------------------ */}
          <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>9. GOVERNING LAW AND JURISDICTION</h4>
          <p>
            This Agreement shall be governed by the laws of Republic of India. You hereby
            consent to the exclusive jurisdiction and venue of courts in New Delhi, India
            in all disputes arising out of or relating to the use of the
            Platforms/Services.
          </p>

          {/* ------------------ POINT 10 ------------------ */}
          <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>10. TERMINATION</h4>
          <p>
            We reserve the right, in our sole discretion, to terminate your access to the
            Platforms and the related Services or any portion thereof at any time, without
            notice.
          </p>

          {/* ------------------ POINT 11 ------------------ */}
          <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>11. CONTACT US</h4>
          <p>
            If you require further information about HHG INDUSTRIES PRIVATE LIMITED or have any
            suggestions concerning how to improve our Services or Platforms, please
            contact our helpdesk/Contact Us. Alternatively, you can write to us at
            inquiry@hhgindia.com.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
